module.exports = __webpack_public_path__ + "img/background-sm.f9ffbfc6.jpg";